"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorrespondenceTemplateContentType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var CorrespondenceTemplateContentType_Factory = /** @class */ (function () {
    function CorrespondenceTemplateContentType_Factory() {
    }
    CorrespondenceTemplateContentType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CorrespondenceTemplateContentType1: model.CorrespondenceTemplateContentType1,
            Description: model.Description,
        };
        return result;
    };
    CorrespondenceTemplateContentType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CorrespondenceTemplateContentType1: model.CorrespondenceTemplateContentType1,
            Description: model.Description,
        };
        return result;
    };
    return CorrespondenceTemplateContentType_Factory;
}());
exports.CorrespondenceTemplateContentType_Factory = CorrespondenceTemplateContentType_Factory;
